































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountDepositBankSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositBankSettings';
// import AccountDepositBankSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/Banking/AccountDepositBankSettingsEditDialog.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositBankSettingsRead', components: { } }) // AccountDepositBankSettingsEditDialog
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountDepositBankSettings;

}
